/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Tomas Burian (burian@cadwork.cz)
 *
 */

import Debug from "js_renderer";
import {vec2, vec3, mat3, mat4} from "gl-matrix";
import AbstractModule from "./abstract_module";

interface IModulesSettings {
    [index: string]: any[];
}

export default
class Settings {

    private static _locked: boolean;
    private static _stack: IModulesSettings = {};
    protected _values: any;

    constructor() {
        //
    }

    public static isLocked(): boolean {
        return this._locked;
    }

    public static lock() {
        Settings._locked = true;
    }

    public static unlock() {
        Settings._locked = false;
    }

    /**
     * Clone settings.
     *
     * @param aDefaultObject Return object deep copy via JSON of an object in param.
     */
    public static clone(aDefaultObject): any {
        // if (aDefaultObject !== undefined && aDefaultObject !== null) {
        //     return JSON.parse(JSON.stringify(aDefaultObject));
        // } else {
        //     return {};
        // }

        let copy: any;

        // Handle the 3 simple types, and null or undefined
        if (null === aDefaultObject || "object" !== typeof aDefaultObject) {
            return aDefaultObject;
        }

        // Handle Date
        if (aDefaultObject instanceof Date) {
            copy = new Date();
            copy.setTime(aDefaultObject.getTime());
            return copy;
        }

        // Handle Array
        if (aDefaultObject instanceof Array) {
            copy = [];
            for (let i = 0, len = aDefaultObject.length; i < len; i++) {
                copy[i] = Settings.clone(aDefaultObject[i]);
            }
            return copy;
        }

        // Handle Float32Array
        // must precede Object
        if (aDefaultObject instanceof Float32Array) {
            copy = {};

            if (aDefaultObject.length === 16) {
                copy = mat4.create();
                copy = mat4.copy(copy, aDefaultObject);
            }
            else if (aDefaultObject.length === 9) {
                copy = mat3.create();
                copy = mat3.copy(copy, aDefaultObject);
            }
            else if (aDefaultObject.length === 3) {
                copy = vec3.create();
                copy = vec3.copy(copy, aDefaultObject);
            }
            else if (aDefaultObject.length === 2) {
                copy = vec2.create();
                copy = vec2.copy(copy, aDefaultObject);
            }

            return copy;
        }

        // Handle Object
        if (aDefaultObject instanceof Object) {
            copy = {};
            for (let attr in aDefaultObject) {
                if (aDefaultObject.hasOwnProperty(attr)) {
                    copy[attr] = Settings.clone(aDefaultObject[attr]);
                }
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    public static serialize(aSettingsObject: any): string {
        return JSON.stringify(aSettingsObject);
    }

    public static deserialize(aSettingsString: string): any {
        return JSON.parse(aSettingsString);
    }

    public static push(aSceneApiModule: AbstractModule) {
        if (!Settings._stack[aSceneApiModule.getType()]) {
            Settings._stack[aSceneApiModule.getType()] = [];
        }
        // let s = aSceneApiModule.getFullSettings();
        Settings._stack[aSceneApiModule.getType()].push(aSceneApiModule.getModuleSettings());
    }

    public static pop(aSceneApiModule: AbstractModule): IModulesSettings {
        let last: IModulesSettings = {};
        if (!Settings._stack[aSceneApiModule.getType()]) {
            Debug.logWarning("Settings stack for module '" + aSceneApiModule.getType() + "' not found");
        }
        else {
            last = Settings._stack[aSceneApiModule.getType()][Settings._stack[aSceneApiModule.getType()].length - 1];
            Settings._stack[aSceneApiModule.getType()].splice(Settings._stack[aSceneApiModule.getType()].length - 1, 1);
        }

        return last;
    }

/*
// jenom odlozeno
    public static doSettings(aModuleName, aSettings, aNewData) {
        // aModuleName = 'zkouska';
        // aSettings = {test: "ano",
        //              obj: {a: "A",
        //                    b: "B",
        //                    c: {
        //                         x: "X",
        //                         y: [1, 2, 3]
        //                    }
        //              }
        // };
        //
        // aNewData = {test: "ne",
        //     obj: {a: "AAA",
        //           b: "BBB",
        //           c: {
        //             x: "XXXX",
        //               y: [2, 4, 6],
        //               z: 2333
        //
        //           },
        //         d: 'd'
        // }
        // };

        this._doSettings(aModuleName, aSettings, aNewData, '');

        console.log(aSettings);
    }

// jenom odlozeno
*/
    // protected static _doSettings(aModuleName, aSettings, aNewData, aPath) {
    //     for (let item in aNewData) {
    //         let path = aPath === '' ? aModuleName : '';
    //         path = aPath + '.' + item;
    //
    //         if (aSettings.hasOwnProperty(item)) {
    //             let key = aSettings[item];
    //             let dataKey = aNewData[item];
    //
    //             if (typeof key === 'object') {
    //                 this._doSettings(aModuleName, key, dataKey, path);
    //             } else {
    //                 aSettings[item] = aNewData[item];
    //             }
    //         } else {
    //             Debug.logWarning("Trying to set a wrong setting path: '" + path + "'");
    //         }
    //     }
    // }

    // public static doSettings(aSettings: any, aNewData: any, aPath: string = '') {
    //     for (let item in aNewData) {
    //         let path = '';
    //         path = aPath + '.' + item;
    //
    //         if (aSettings.hasOwnProperty(item)) {
    //             let key = aSettings[item];
    //             let dataKey = aNewData[item];
    //
    //             if (typeof key === 'object') {
    //                 Settings.doSettings(key, dataKey, path);
    //             } else {
    //                 aSettings[item] = aNewData[item];
    //             }
    //         } else {
    //             Debug.logWarning("Trying to set a wrong setting path: '" + path + "'");
    //         }
    //     }
    // }

}
